// @ts-nocheck
import { HasOnComplete } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    submitPackagingAdviceForm,
    SubmitPackagingAdviceFormApiParameter,
    SubmitPackagingAdviceFormModel,
} from "@store/Framework/Services/PackagingAdviceService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type ApiResult = SubmitPackagingAdviceFormModel;
type ApiParameter = SubmitPackagingAdviceFormApiParameter;
type Parameter = ApiParameter & HasOnSuccess<ApiResult> & HasOnError<string> & HasOnComplete<void>;

type HandlerType = ApiHandlerDiscreteParameter<Parameter, ApiParameter, ServiceResult<ApiResult>>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, onComplete, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await submitPackagingAdviceForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const ExecuteOnCompleteCallback: HandlerType = props => {
    props.parameter.onComplete?.();
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
    ExecuteOnCompleteCallback,
];

const submitForm = createHandlerChainRunner(chain, "SubmitForm");
export default submitForm;
